<!-- Copyright (c) ArubaCC - All Rights Reserved. -->

<div
  [ngClass]="{ hidden: !isVisible }"
  data-ut-id="notificationBar"
  class="notification-container py-3 px-5 mb-3 w-full flex {{ type | lowercase }}"
  >
  <div class="flex mr-3 items-start" [ngClass]="{ 'sm:items-center': !title }">
    <mat-icon [svgIcon]="type | lowercase"></mat-icon>
  </div>

  <div class="w-full flex justify-between flex-col sm:flex-row sm:items-center mr-2">
    <div class="flex flex-col text-left">
      @if (title) {
        <span class="font-bold my-1">{{ title }}</span>
      }
      <span class="mb-3 sm:mb-0">{{ message }}</span>
    </div>
    <div class="flex items-center">
      @if (ctaUrl) {
        <a mat-flat-button color="primary" [routerLink]="ctaUrl" [queryParams]="ctaQueryParams">
          <span class="uppercase">{{ 'COMMON.MANAGE' | transloco }}</span>
        </a>
      }
    </div>
  </div>

  @if (dismissable) {
    <button type="button" class="self-center" mat-icon-button (click)="onClose()">
      <mat-icon fontIcon="close"></mat-icon>
    </button>
  }
</div>
